import React, { useState } from 'react';
import { useToast } from '../../../hooks/toast';
import TemplateGenerator from './TemplateGenerator';
import * as XLSX from "xlsx";
import api from "../../../services/api";

const currentYear = new Date().getFullYear();
const yearsSource = Array.from({ length: 21 }, (_, i) => currentYear - 10 + i);

export default function Import() {
  const [year, setYear] = useState(null);
  const { addToast } = useToast(); 
  const [isGenerating, setIsGenerating] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const handleGenerateTemplate = async () => {
    try {
      setIsGenerating(true);
      addToast({
        type: "info",
        title: "Generating Template",
        description: "The template is being generated, please wait...",
      });

      const response = await api.get(`/api/counseling?year=${year}`);
      console.log("response data:", response.data); 

      const filteredData = response.data.filter(item => item.year === year);
      console.log("filter:", filteredData); 

      const data = filteredData.map((item, index) => {
        console.log("item:", item); 
        return {
          id: item.id,
          professional: item.professional?.name || "Unknown", // Ensure professional name is included
          year: item.year,
          conclusion: "", 
        };
      });

      console.log("data:", data); 

      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Template");

      XLSX.writeFile(workbook, `Template_${year}.xlsx`);

      addToast({
        type: "success",
        title: "Template Generated",
        description: "The template has been generated successfully.",
      });
    } catch (error) {
      addToast({
        type: "error",
        title: "Error Generating Template",
        description: "There was an error generating the template. Please try again.",
      });
      console.error("Error generating template:", error);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleUpload = async (data) => {
    try {
      setIsUploading(true);
      const updatedData = data.map(item => ({
        ...item,
        ConclusionKeyMessage: item.conclusion
      }));

      await api.post('/api/counseling/upload', updatedData);
      addToast({
        type: "success",
        title: "Upload Successful",
        description: "The data has been uploaded successfully.",
      });
    } catch (error) {
      addToast({
        type: "error",
        title: "Error Uploading Data",
        description: "There was an error uploading the data. Please try again.",
      });
      console.error("Error uploading data:", error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <TemplateGenerator 
      section={"counseling"}
      yearsSource={yearsSource}
      year={year}
      setYear={setYear}
      handleGenerateTemplate={handleGenerateTemplate}
      handleUpload={handleUpload}
      isGenerating={isGenerating}
      isUploading={isUploading}
    />
  );
}